export var ERROR_TEXT = "No schema in data / format of the data is wrong. Please see console logs for more information";